// extracted by mini-css-extract-plugin
export default {"panel":"KWhB","content":"zsG3"};